import React from 'react';
export function HeroStats() {
  return <div className="max-w-5xl mx-auto px-4 flex flex-col items-center" data-id="element-158">
      {/* Stats Bar */}
      <div className="w-full grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 bg-brand-card border border-brand-border rounded-2xl md:rounded-3xl p-5 md:p-8" data-id="element-159">
        <div className="text-center" data-id="element-160">
          <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-161">
            +2.000
          </div>
          <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-162">
            docentes confían
          </div>
        </div>
        <div className="text-center" data-id="element-163">
          <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-164">
            12
          </div>
          <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-165">
            Tomos completamente listos
          </div>
        </div>
        <div className="text-center" data-id="element-166">
          <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-167">
            4.9/5 ⭐
          </div>
          <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-168">
            calificación
          </div>
        </div>
        <div className="text-center" data-id="element-169">
          <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-170">
            🇦🇷
          </div>
          <div className="text-xs md:text-sm text-white/70 font-medium uppercase tracking-wider" data-id="element-171">
            Todo el país — primaria y secundaria
          </div>
        </div>
      </div>

      {/* Hero Testimonials */}
      <div className="mt-8 md:mt-12 w-full grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-172">
        {[{
        initials: 'MG',
        name: 'Mariela G.',
        loc: 'Córdoba | Primaria',
        quote: 'Organicé todo el año de Matemática en una tarde'
      }, {
        initials: 'LP',
        name: 'Laura P.',
        loc: 'Rosario | Secundaria',
        quote: 'Mis clases de secundaria por fin tienen estructura real'
      }, {
        initials: 'RM',
        name: 'Roberto M.',
        loc: 'Buenos Aires | Primaria y Sec.',
        quote: 'Nunca más llegué a clase sin saber qué dar'
      }].map((test, i) => <div key={i} className="bg-brand-card border border-brand-border rounded-xl md:rounded-2xl p-4 md:p-6 text-left" data-id="element-173">
            <div className="flex items-center gap-3 mb-3" data-id="element-174">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-brand-accent/10 border border-brand-accent/20 flex items-center justify-center font-heading font-bold text-brand-accent text-sm md:text-base" aria-hidden="true" data-id="element-175">
                {test.initials}
              </div>
              <span className="text-brand-accent text-sm" aria-label="5 estrellas" data-id="element-176">
                ⭐⭐⭐⭐⭐
              </span>
            </div>
            <p className="text-white/90 font-medium italic mb-3 leading-relaxed text-sm md:text-base" data-id="element-177">
              "{test.quote}"
            </p>
            <div className="text-[10px] md:text-xs text-white/70 uppercase tracking-wider font-bold" data-id="element-178">
              — {test.name}, {test.loc}
            </div>
          </div>)}
      </div>
    </div>;
}